import api from './api.js';
import wx from 'weixin-js-sdk';
import util from 'ahaapi';
const sha1 = require('js-sha1');
const appid = 'wxc17e1b4c4aceccbb'
let commen = {};

// 生成16位随机字符串
function randomString(len) {
	len = len || 32;
	var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
	var maxPos = $chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}

export default {
	isWeiXin() {
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true; // 是微信端
		} else {
			return false;
		}
	},
	isphone() {
		let flag = navigator.userAgent.match(
			/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		);
		if (flag) {
			return true; // 是手机端
		} else {
			return false;
		}
	},


	getQueryString() {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) {
			return unescape(r[2]);
		} else {
			return null;
		}
	},

	setwxShare() {
		const urlArr = window.location.href.split('#');
		wx.ready(function() {
			//“分享给朋友”
			wx.onMenuShareAppMessage({
				title: '第一次全国细菌真菌感染学术会议',
				desc: '欢迎您的访问',
				link: window.location.origin + window.location.pathname +
					'?initial=wechat&hash=' + encodeURIComponent(urlArr[1]),
				imgUrl: "https://w.ganzhiyu.com/shareDemo/share_logo.png"
			}, function(res) {
				//这里是回调函数 
			});
			//“分享到朋友圈”
			wx.onMenuShareTimeline({
				title: '第一次全国细菌真菌感染学术会议',
				desc: '欢迎您的访问',
				link: window.location.origin + window.location.pathname +
					'?initial=wechat&hash=' + encodeURIComponent(urlArr[1]),
				imgUrl: "https://w.ganzhiyu.com/shareDemo/share_logo.png"
			}, function(res) {
				//这里是回调函数 
			});
		});
	},

	initwxConfig() {
		let cnt = {};
		api.getJsapiTicket(cnt, res => {
			if (res.data && res.data.rc == util.RC.SUCCESS) {
				const noncestr = randomString(16);
				const jsapi_ticket = res.data.c
				let timestamp = new Date().getTime()
				timestamp = timestamp.toString().substr(0, 10);
				const urlArr = window.location.href.split('#');
				let str =
					`jsapi_ticket=${jsapi_ticket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${urlArr[0]}`
				str = sha1(str)
				wx.config({
					debug: false,
					appId: appid,
					timestamp: timestamp,
					nonceStr: noncestr,
					signature: str,
					jsApiList: [
						// "chooseWXPay", // 微信支付
						// "chooseImage", // 选择图片？？
						"onMenuShareTimeline", // 分享朋友圈
						"onMenuShareAppMessage", // 分享给朋友
						// "getLocalImgData", // 获取本地缓存图片
						"updateAppMessageShareData"
					]
				})
			}
		})
	}
}
